module.exports = __webpack_public_path__ + "img/word-cloud-light-01.877244aa.jpg";